import { NextSeo } from 'next-seo';
import * as Sentry from '@sentry/nextjs';

import withPageBanner from '@/components/core/withPageBanner';
import Content from '@/components/ui/main/simple-content';
import RichText from '@/components/rich-text-markdown';
import { SEOMetadata } from '@/config/seo-meta.js';
import { getTermsAndConditions } from '@/services/legal-documents.service';
import { getNavigation } from '@/services/navigation';

export default function TermsAndConditions({ contentPrefetch }) {
  const { seo, title, content } = contentPrefetch;

  return (
    <>
      <NextSeo
        title={seo.title}
        description={seo.description}
        canonical={`${SEOMetadata.baseCanonical}/legal/terms-and-conditions`}
        openGraph={{
          url: `${SEOMetadata.baseCanonical}/legal/terms-and-conditions`,
          title: seo.title,
          description: seo.description,
        }}
      />

      <Content title={title}>
        <RichText content={content} />
      </Content>
    </>
  );
}

export const getStaticProps = withPageBanner(async () => {
  try {
    const contentPrefetch = await getTermsAndConditions();
    const navigation = await getNavigation();

    return {
      props: {
        contentPrefetch,
        navigation,
      },
      revalidate: 60,
    };
  } catch (error) {
    Sentry.captureException(error);

    if (error.response?.status === 404) {
      return {
        notFound: true,
        revalidate: 60,
      };
    }

    throw new Error('Failed to fetch Terms and Conditions data');
  }
});
